import isObject from 'lodash/isObject'
import { z } from 'zod'

export const ERP_SYNC_SOURCE = 'ERP' as const
export const SSO_SYNC_SOURCE = 'SSO' as const
export const PUBLIC_API_SYNC_SOURCE = 'PUBLIC_API' as const

const StringSyncSourceSchema = z.enum([SSO_SYNC_SOURCE, ERP_SYNC_SOURCE])

const PUBLIC_API_SYNC_SOURCE_SCHEMA = z.object({
  type: z.literal(PUBLIC_API_SYNC_SOURCE),
  integrationId: z.string(),
})

// TODO (TOM): We will migrate this schema fully to a tagged union type once we have scoped out the required changes to the ERP_SYNC_SOURCE schema to support multi erp + p2p
export const SyncSourceSchema = z.union([StringSyncSourceSchema, PUBLIC_API_SYNC_SOURCE_SCHEMA])

export const SYNC_SOURCE_OPTIONS = [SSO_SYNC_SOURCE, ERP_SYNC_SOURCE] as const

export const UserSyncConfigSchema = z.object({
  manager: SyncSourceSchema,
  department: SyncSourceSchema,
  subsidiary: SyncSourceSchema,
  allowedSubsidiaries: SyncSourceSchema,
  /** When false, subsidiary dropdowns show all org subsidiaries and we do not read user_allowed_subsidiaries. */
  filterSubsidiariesByUserAllowed: z.boolean().optional().default(true),
})

export type UserSyncConfig = z.infer<typeof UserSyncConfigSchema>
export type SyncSource = z.infer<typeof SyncSourceSchema>

export const isSourceSSO = (source: SyncSource): source is 'SSO' => source === SSO_SYNC_SOURCE

export const isSourceERP = (source: SyncSource): source is 'ERP' => source === ERP_SYNC_SOURCE

export const isSourcePublicApi = (source: SyncSource): source is z.infer<typeof PUBLIC_API_SYNC_SOURCE_SCHEMA> =>
  isObject(source) && source.type === PUBLIC_API_SYNC_SOURCE

export const defaultUserSyncConfig = UserSyncConfigSchema.parse({
  manager: 'SSO',
  department: 'SSO',
  subsidiary: 'SSO',
  allowedSubsidiaries: 'ERP',
  filterSubsidiariesByUserAllowed: true,
})
